import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import logo from '../assets/icons/logoWhite.png';
import { useSpell } from '../state';

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [notification, setNotification] = useState(null);
  const spell = useSpell();

  useEffect(() => {
    if (location.state?.notification) {
      setNotification(location.state.notification);

      const timer = setTimeout(() => {
        setNotification(null);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [location]);

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-gradient-to-b page-background text-white">
      {notification && (
        <div className={`absolute top-4 left-1/2 -translate-x-1/2 p-4 rounded-md shadow-lg ${notification.type === 'success' ? 'bg-green-100 border-green-500 text-green-800' : 'bg-red-100 border-red-500 text-red-800'} border-l-4 max-w-md z-50 flex items-center`}>
          <div>
            {notification.message}
          </div>
          <button
            onClick={() => setNotification(null)}
            className="ml-4 text-gray-500 hover:text-gray-700"
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
      )}

      <div className="absolute top-4 right-4 z-40 flex items-center gap-3">
        <button
          onClick={handleLoginClick}
          className="px-4 py-2 rounded-lg font-semibold text-white border border-white/30 bg-white/10 hover:bg-white/20 shadow-sm backdrop-blur-sm transition"
        >
          Log in
        </button>
        <button
          onClick={handleRegisterClick}
          className="px-4 py-2 rounded-lg font-semibold text-teal-700 bg-white hover:bg-teal-50 shadow"
        >
          Sign up
        </button>
      </div>

      <section className="flex flex-col items-center justify-center text-center px-6 py-24 md:py-36">
        <img src={logo} className="h-16 sm:h-20 md:h-24 w-auto mb-16" alt="tipl logo" />
        <h1 className="text-4xl font-semibold font-sans tracking-tight pb-6">
          Collect tips online, the easy way
        </h1>
        <p className="mt-4 max-w-2xl text-base sm:text-lg md:text-xl text-white/90 pb-2">
          Designed for creators, musicians and hospitality workers
        </p>
        <div className="mt-8 w-full grid grid-cols-[1fr_auto_1fr] items-center gap-3">
          <span aria-hidden="true"></span>
          <button
            onClick={handleRegisterClick}
            className="px-6 py-3 rounded-xl font-semibold bg-[#FF6F61] hover:bg-[#de6054] text-white focus:outline-none focus:ring-4 focus:ring-white/40 transition"
          >
            Get started
          </button>
          <span className="text-xs font-semibold text-white/90 justify-self-start">← It’s free!</span>
        </div>
      </section>

      <section className="text-white -mt-6 md:-mt-10 pb-16 text-center">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="flex-1">
              <div>
                <div className=" mb-3 w-10 h-10 grid place-items-center rounded-full bg-white/20 text-white font-bold mx-auto">1</div>
                <h3 className="text-xl font-semibold">
                  <a href="/register" className="hover:underline">Sign up</a> in two minutes
                </h3>
              </div>
            </div>

            <div className="flex-1">
              <div>
                <div className="mb-3 w-10 h-10 grid place-items-center rounded-full bg-white/20 text-white font-bold mx-auto">2</div>
                <h3 className="text-xl font-semibold">Get your link, QR code and button</h3>
              </div>
            </div>

            <div className="flex-1">
              <div>
                <div className="mb-3 w-10 h-10 grid place-items-center rounded-full bg-white/20 text-white font-bold mx-auto">3</div>
                <h3 className="text-xl font-semibold">Share with your audience and start collecting tips</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="space-y-12">
            <div className="bg-[#FF6F61] rounded-3xl p-8 md:p-12 max-w-2xl mx-auto">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="order-2 md:order-1">
                  <h3 className="text-3xl font-semibold mb-6 text-white">Make it yours</h3>
                  <p className="text-lg text-white/90 mb-6">
                    {spell('Personalize')} your page, button and QR code with your own {spell('color')}s and branding.
                  </p>
                  {/* <ul className="space-y-3 text-white/90">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Custom themes and color schemes
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Logo and brand integration
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Flexible layout options
                    </li>
                  </ul> */}
                </div>
                <div className="order-1 md:order-2 flex justify-center">
                  <div className="w-64 h-48 bg-white/20 rounded-2xl flex items-center justify-center">
                    <svg className="w-24 h-24 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#F5E6D3] rounded-3xl p-8 md:p-12 max-w-2xl mx-auto">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="order-2 md:order-1">
                  <h3 className="text-3xl font-semibold mb-6 text-gray-800">Secure payments</h3>
                  <p className="text-lg text-gray-700 mb-6">
                    Accept tips instantly by card, Google Pay, Apply Pay and more, with bank-grade security.
                  </p>
                  {/* <ul className="space-y-3 text-gray-700">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Bank-grade encryption
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Multiple payment methods
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Instant processing
                    </li>
                  </ul> */}
                </div>
                <div className="order-1 md:order-2 flex justify-center">
                  <div className="w-64 h-48 bg-white/30 rounded-2xl flex items-center justify-center">
                    <svg className="w-24 h-24 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#edcd4d] rounded-3xl p-8 md:p-12 max-w-2xl mx-auto">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="order-2 md:order-1">
                  <h3 className="text-3xl font-semibold mb-6 text-gray-800">Understand your audience</h3>
                  {/* <p className="text-lg text-gray-700 mb-6">
                    Track your earnings and {spell('optimize')} your tip collection with analysis of your tip sources.
                  </p> */}
                  <p className="text-lg text-gray-700 mb-6">
                    Track and increase your earnings with analysis of your tip sources.
                  </p>
                  {/* <ul className="space-y-3 text-gray-700">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Real-time earnings tracking
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Audience insights
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Exportable reports
                    </li>
                  </ul> */}
                </div>
                <div className="order-1 md:order-2 flex justify-center">
                  <div className="w-64 h-48 bg-white/30 rounded-2xl flex items-center justify-center">
                    <svg className="w-24 h-24 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M3 3v18h18v-2H5V3H3zm4 14h2v-6H7v6zm4 0h2V9h-2v8zm4 0h2v-4h-2v4z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="absolute bottom-0 left-0 right-0 py-4 text-center text-white/80 text-sm">
        <div className="container mx-auto">
          <span>&copy; {new Date().getFullYear()} Tipl</span>
          <span className="mx-2">·</span>
          <Link to="/privacy" className="underline hover:text-white">Privacy</Link>
          <span className="mx-2">·</span>
          <Link to="/terms" className="underline hover:text-white">Terms</Link>
          <span className="mx-2">·</span>
          <Link to="/contact" className="underline hover:text-white">Contact</Link>
        </div>
      </footer>
    </div>
  );
};

export default Home;
